export default __webpack_public_path__ + "static/media/shopifyIcon.d86dbdd0.svg";